import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { UseMutationsParams } from "@/shared/interfaces";
import { ITransitoInventario, ITransitoInventarioPagingResp, ITransitoInventarioParams } from "@/shared/interfaces/erp/administration/transito_inventario.interface";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, post, put } = erpApi();

///* crear recepcion transferencia de inventario

export const useFetchPostTransitoInventario = ({
  enableSuccessAlert = true,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: postTransitoInventario,
    onSuccess: (data, { id_transito_inventario }) => {
      queryClient.invalidateQueries({ queryKey: ['transitoinventario', id_transito_inventario] });

      enableSuccessAlert &&
        setAlert(true, data.message, data.status);
    },
    onError: (error) => {
      handleAxiosError(error)
    },
    onSettled: () => {

    }
  });
};

export const postTransitoInventario = async (
  data: ITransitoInventarioParams
) => {
  const resp = await post<ITransitoInventario>(
    `${urlBackend}api/v1/transitoinventario/`,
    data,
    true
  );
  return resp;
};

///* actualizar una transferencia de inventario por su id 

export const useFetchPutTransitoInventario = ({
  navigate,
  returnUrl
}: UseMutationsParams) => {

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: {
      id: string,
      data: ITransitoInventarioParams
    }) => {
      return putTransitoInventario(id, data);
    },
    onSuccess: (_data,) => {
      queryClient.invalidateQueries({ queryKey: ['transitoinventario'] });

      navigate && returnUrl && navigate(returnUrl)
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {

    }
  });
}

export const putTransitoInventario = async (
  id: string,
  data: ITransitoInventarioParams
) => {
  const resp = await put<ITransitoInventario>(
    `${urlBackend}api/v1/transitoinventario/${id}/`,
    data,
    true
  );
  return resp;
};

///* obtener todas las recepcion de transferencia inventario

export const useFetchGetTransitoInventario = (
  params?: ITransitoInventarioParams,
  enabled = true
) => {
  return useQuery({
    queryKey: ['transitoinventario', ...Object.values(params || {})],
    queryFn: async () => {
      return await getTransitoInventario(params);
    },
    enabled,
  });
};


export const getTransitoInventario = async (
  params?: ITransitoInventarioParams
) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<ITransitoInventarioPagingResp>(
    `${urlBackend}api/v1/transitoinventario/?${queryParams}`,
    true
  );
  return resp;
};

///* obtener recepcion de transferencia de inventario por su id

export const useFetchGetTransitoInventarioById = (id: string) => {
  return useQuery({
    queryKey: ['transitoinventario', id],
    queryFn: async () => {
      return await getTransitoInventarioById(id);
    },
  });
};

export const getTransitoInventarioById = async (id: string) => {
  const resp = await get<ITransitoInventario>(
    `${urlBackend}api/v1/transitoinventario/${id}`,
    true
  );
  return resp.data;
};


export const transitoInventarioArchivoRecepcion = async (
  data?: FormData
) => {
  const resp = await post<ITransitoInventario>(
    `${urlBackend}api/v1/transitoinventario-archivo/`,
    data,
    true,
    false
  );
  return resp;
};